import {
  Components,
  formControlLabelClasses,
  radioClasses,
  Theme,
} from '@mui/material';

function RadioIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="var(--radio-background)"
        stroke="var(--radio-border)"
        strokeWidth="2"
      />
      <circle cx="12" cy="12" r="5" fill="var(--radio-checked)" />
    </svg>
  );
}

export const getMuiRadio = (theme: Theme): Components['MuiRadio'] => ({
  defaultProps: {
    checkedIcon: <RadioIcon />,
    icon: <RadioIcon />,
  },

  styleOverrides: {
    root: {
      textTransform: 'none',
      fontFeatureSettings: "'case' on, 'cv11' on, 'calt' off",
      boxShadow: 'none',
      padding: 0,

      '--radio-background': theme.palette.background.paper,
      '--radio-border': theme.palette.grey[600],
      '--radio-checked': 'unset',

      '&:hover': {
        '--radio-background': theme.palette.grey[100],
      },

      [`&.${radioClasses.checked}`]: {
        '--radio-background': theme.palette.primary.main,
        '--radio-border': 'unset',
        '--radio-checked': theme.palette.background.paper,

        '&:hover': {
          '--radio-background': theme.palette.primary.dark,
        },
      },

      [`&.${radioClasses.disabled}`]: {
        '--radio-background': theme.palette.grey[100],
        '--radio-border': theme.palette.grey[100],
        '--radio-checked': 'unset',

        [`&.${radioClasses.checked}`]: {
          '--radio-checked': theme.palette.grey[400],
        },
      },
    },
  },

  variants: [
    {
      props: { size: 'medium' },
      style: {
        width: 24,
        height: 24,

        [`+.${formControlLabelClasses.label}`]: {
          margin: theme.spacing(0, 0, 0, 3),
          fontWeight: 400,
          fontSize: 16,
          lineHeight: 1.5,
        },
      },
    },
    {
      props: { size: 'small' },
      style: {
        width: 18,
        height: 18,

        [`+.${formControlLabelClasses.label}`]: {
          margin: theme.spacing(0, 0, 0, 3),
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 1.43,
          letterSpacing: '0.01em',
        },
      },
    },
  ],
});
